import { render, staticRenderFns } from "./CollectionOutstandingBalance.vue?vue&type=template&id=85da072e&scoped=true&"
import script from "./CollectionOutstandingBalance.vue?vue&type=script&lang=ts&"
export * from "./CollectionOutstandingBalance.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionOutstandingBalance.vue?vue&type=style&index=0&id=85da072e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85da072e",
  null
  
)

export default component.exports